// extracted by mini-css-extract-plugin
export default {"Pagination":"Pagination_Pagination__5iSI8","selected":"Pagination_selected__Jk2Ir"};